export default __webpack_public_path__ + "logo-light.b1f91cca508a96554b8140e28fc74652.svg";